/*
 * DATORACODE - Staffelpreis-Leiste im Cart-Drawer.
 * Zeigt die Mengenrabatt-Stufen (disc_perc + "ab cond_quant") und hebt die aktuell
 * erreichte Stufe hervor. Datenquelle: co2.unlimitedCondDiscounts(allProductsTag).
 * Mechanik analog assets/free-products.js (Trailing-Edge-Debounce, Reaktion auf
 * co2.cart.initialized + PUB_SUB_EVENTS.cartRerendered, da co2 teils vor dem DOM-Replace feuert).
 * Unabhängig von den Gratisprodukten — keine Verzahnung, disc_perc === 100 ist kein Sonderfall.
 */
(function () {
  /* Trailing-edge: während ein Cycle läuft, kommende Events nur als pending markieren. */
  var isHandling = false;
  var pending = false;

  /* ─── Settings ──────────────────────────────────────────────── */

  function getSettings() {
    var el = document.getElementById('tiered-pricing-settings');
    if (!el) return {};
    try {
      return JSON.parse(el.textContent) || {};
    } catch (e) {
      return {};
    }
  }

  var allProductsTag = getSettings().allProductsTag || '';

  /* ─── Helpers ───────────────────────────────────────────────── */

  function getRoot() {
    return document.querySelector('[data-tiered-pricing-root]');
  }

  function hideBar() {
    var root = getRoot();
    if (!root) return;
    root.hidden = true;
    root.innerHTML = '';
  }

  function showBar(html) {
    var root = getRoot();
    if (!root) return;
    root.innerHTML = html;
    root.hidden = false;
  }

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  /* Lokalisiertes Template aus data-text-* füllen: {{ key }} → value (escaped). */
  function fill(template, vars) {
    var out = escapeHtml(String(template || ''));
    Object.keys(vars).forEach(function (key) {
      var re = new RegExp('\\{\\{\\s*' + key + '\\s*\\}\\}', 'g');
      out = out.replace(re, escapeHtml(String(vars[key])));
    });
    return out;
  }

  /* ─── Render ────────────────────────────────────────────────── */

  function buildStatus(root, tiers, qty, activeTier, nextTier) {
    var first = tiers[0];

    if (!activeTier) {
      // Noch keine Stufe erreicht → Singular/Plural nach quant der ersten Stufe.
      var usePlural = first.cond_quant !== 1;
      var tpl = usePlural ? root.dataset.textStatusNonePlural : root.dataset.textStatusNoneSingular;
      return fill(tpl, { quant: first.cond_quant, percent: first.disc_perc });
    }

    if (nextTier) {
      // Aktive Stufe mit nächster Stufe → Singular/Plural nach remaining.
      var remaining = nextTier.cond_quant - qty;
      var usePluralActive = remaining !== 1;
      var tplActive = usePluralActive
        ? root.dataset.textStatusActivePlural
        : root.dataset.textStatusActiveSingular;
      return fill(tplActive, {
        current: activeTier.disc_perc,
        remaining: remaining,
        next: nextTier.disc_perc,
      });
    }

    // Höchste Stufe erreicht.
    return fill(root.dataset.textStatusMax, { current: activeTier.disc_perc });
  }

  function buildSteps(root, tiers, qty, activeTier) {
    var fromTpl = root.dataset.textTierFrom;
    return tiers
      .map(function (tier) {
        var reached = tier.cond_quant <= qty;
        var stateClass = reached
          ? 'cart-drawer__tiered-pricing__step--reached'
          : 'cart-drawer__tiered-pricing__step--upcoming';
        if (tier === activeTier) {
          stateClass += ' cart-drawer__tiered-pricing__step--active';
        }
        return (
          '<li class="cart-drawer__tiered-pricing__step ' + stateClass + '">' +
            '<span class="cart-drawer__tiered-pricing__bar">' +
              '<span class="cart-drawer__tiered-pricing__perc">' + escapeHtml(tier.disc_perc + '%') + '</span>' +
            '</span>' +
            '<span class="cart-drawer__tiered-pricing__from">' +
              fill(fromTpl, { quant: tier.cond_quant }) +
            '</span>' +
          '</li>'
        );
      })
      .join('');
  }

  function render(tiers) {
    var root = getRoot();
    if (!root) return;

    // Defensiv aufsteigend nach cond_quant sortieren.
    tiers = tiers.slice().sort(function (a, b) {
      return a.cond_quant - b.cond_quant;
    });

    // Aktuell qualifizierende Menge: nur die aktive Regel trägt count.
    var qty = 0;
    tiers.forEach(function (t) {
      if (t.count && t.count > qty) qty = t.count;
    });

    // Aktive Stufe = höchste erreichte; nächste Stufe = erste mit cond_quant > qty.
    var activeTier = null;
    var nextTier = null;
    tiers.forEach(function (t) {
      if (t.cond_quant <= qty) {
        activeTier = t;
      } else if (!nextTier) {
        nextTier = t;
      }
    });

    showBar(
      '<div class="cart-drawer__tiered-pricing__status">' +
        buildStatus(root, tiers, qty, activeTier, nextTier) +
      '</div>' +
      '<ol class="cart-drawer__tiered-pricing__steps">' +
        buildSteps(root, tiers, qty, activeTier) +
      '</ol>'
    );
  }

  /* ─── Main Cycle ────────────────────────────────────────────── */

  async function updateUI() {
    try {
      var tiers = await co2.unlimitedCondDiscounts(allProductsTag);
      if (!tiers || tiers.length === 0) {
        hideBar();
        return;
      }
      render(tiers);
    } catch (e) {
      // co2 kann ablehnen/werfen (Bridge/Netzwerk) → Leiste verstecken statt Stale-UI
      hideBar();
    }
  }

  async function triggerCycle() {
    if (typeof co2 === 'undefined' || typeof co2.unlimitedCondDiscounts !== 'function') return;
    if (isHandling) {
      pending = true;
      return;
    }
    isHandling = true;
    try {
      do {
        pending = false;
        await updateUI();
      } while (pending);
    } finally {
      isHandling = false;
    }
  }

  /* Zwei Trigger (wie free-products.js):
     - co2.cart.initialized: co2 hat frische Daten
     - PUB_SUB_EVENTS.cartRerendered: drawer-inner wurde neu in den DOM geschrieben;
       fängt den Fall ab, dass co2 vor dem replaceWith feuert. Trailing-edge de-dupt. */
  window.addEventListener('co2.cart.initialized', triggerCycle);
  subscribe(PUB_SUB_EVENTS.cartRerendered, triggerCycle);
})();
